import { createContainer, type OverrideContainerComponent } from 'react-sweet-state';

import { store } from './store';

export const FeedbackCollectorContainer: OverrideContainerComponent<unknown> =
	createContainer(store);
